/** @format */

import React, { FC, useState, useEffect, useMemo } from 'react'
import styled from 'styled-components'
import { _$, Dialog, Button, Icon, Radio, Transfer, Table, Tip } from 'kpc-react'
import useTableGroup from 'src/hooks/useTableGroup'
// eslint-disable-next-line max-len
import CloudListTableCopyTips from 'src/containers/MonitorCloud/CloudListTable/CloudListTableCopyTips'
import { MonitorSearch } from 'src/components'

interface DimensionDialogProps {
  className?: string
  values: string[]
  tags: string[]
  max?: number
  unmatch_instances: any[]
  onChange: (values: string[]) => void
}
const DimensionDialog: FC<DimensionDialogProps> = ({
  className,
  values: valuesprop,
  tags,
  max,
  unmatch_instances,
  onChange
}) => {
  const [visible, setVisible] = useState<boolean>(false)
  const [values, setValues] = useState<any[]>([])
  // 未匹配资源提示
  const [unmatchVisible, setUnmatchVisible] = useState<boolean>(false)
  const [selectedGroup, setSelectedGroup] = useState<{ region: string }>({ region: '' })
  const regionGroup = useTableGroup('monitorRegionList')

  useEffect(() => {
    if (visible) {
      setValues(valuesprop?.map(item => ({ label: item, key: item })) || [])
    }
  }, [valuesprop, visible])

  // 筛选未匹配维度的资源
  const unmatch_table = useMemo(() => {
    const region = selectedGroup.region
    if (region) {
      const regionFilter = unmatch_instances.filter(instance => {
        return region ? instance.region === region : true
      })
      return regionFilter
    } else {
      return unmatch_instances
    }
  }, [unmatch_instances, selectedGroup.region])

  const scheme = {
    instanceName: {
      title: _$('实例名称'),
      template({ instanceName, instanceId }) {
        return (
          <div style={{ display: 'flex', alignContent: 'center' }}>
            <p className="text-overflow">{instanceName}</p>
            <CloudListTableCopyTips instanceId={instanceId} />
          </div>
        )
      }
    },
    instanceIP: _$('IP地址'),
    region: {
      title: _$('region'),
      width: 200,
      group: regionGroup,
      template(item) {
        const find = regionGroup.find(({ value }) => item.region === value)
        return find?.label || item.region
      }
    },
    unselectedMetricTags: {
      title: _$('未匹配纬度'),
      template({ unselectedMetricTags }) {
        return unselectedMetricTags.join('、')
      }
    }
  }

  return (
    <div className={className}>
      <div>
        <Radio name="" trueValue="instanceRadio" value="instanceRadio">
          {_$('自选维度')}({<span className="primaryicon">{valuesprop?.length || 0}</span>})
        </Radio>
      </div>
      <div className="select_button">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true)
          }}
        >
          <Icon className="ion-plus-round" size="small" />
          {_$('选择维度')}
        </Button>
        {unmatch_instances?.length ? (
          <p
            className="unmatch_tip"
            onClick={() => {
              setUnmatchVisible(true)
            }}
          >
            资源未匹配维度({unmatch_instances?.length})
          </p>
        ) : null}
      </div>
      <Dialog
        value={visible}
        width={610}
        disabledOk={!values?.length || values?.length > max}
        on$change-value={(c, show) => {
          if (!show) {
            setVisible(false)
          }
        }}
        onOk={() => {
          onChange(values.map(item => item.key))
          setVisible(false)
        }}
        title={_$('维度选择')}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'center',
            flexWrap: 'wrap'
          }}
        >
          {max ? (
            <div style={{ marginBottom: 16 }}>
              <Tip type="warning" style={{ marginBottom: 16 }}>
                当前资源监控项维度最大支持勾选{max}个
              </Tip>
            </div>
          ) : null}
          {tags?.length ? (
            <Transfer
              data={tags?.map(item => ({ label: item, key: item }))}
              filter={(data, keywords) => {
                return data.key.includes(keywords)
              }}
              filterable
              keyName="key"
              value={values}
              on$change-value={(c, value) => {
                setValues(value)
              }}
            ></Transfer>
          ) : null}
        </div>
      </Dialog>
      <Dialog
        value={unmatchVisible}
        onOk={() => {
          setUnmatchVisible(false)
        }}
        on$change-value={(c, show) => {
          if (!show) {
            setUnmatchVisible(false)
            setSelectedGroup({ region: '' })
          }
        }}
        title={_$('资源未匹配维度')}
      >
        <div style={{ marginBottom: 16 }}>
          <Tip type="warning">资源实例存在未匹配的纬度信息</Tip>
        </div>
        <Table
          scheme={scheme}
          data={unmatch_table}
          checkType="none"
          group={selectedGroup}
          on$change-group={(_c, value) => {
            setSelectedGroup(value)
          }}
          rowKey={value => value.instanceId}
        ></Table>
      </Dialog>
    </div>
  )
}

export default styled(DimensionDialog)`
  margin-top: 6px;
  .select_button {
    display: flex;
    margin-top: 16px;
    align-items: center;
  }
  .unmatch_tip {
    color: #ff4133;
    margin: 0 0 0 16px;
    cursor: pointer;
  }
`
